import { ISpecialtyView } from './getSpecialties';

export function getCssSpecialtyName(specialtyPrepared: ISpecialtyView | null) {
  return specialtyPrepared?.specialtiesIcon && specialtyPrepared.specialtiesIcon.length > 2
    ? 'specialty-vertical'
    : 'specialty-horizontal';
}
